import { Helpers } from '../../helpers';
import { IThirdPartyConstraintType } from '../../interfaces/ithird-party-constraint-type';
import { AssetThirdPartyConstraint } from '../asset-third-party-constraint';

export class ThirdPartyConstraintTypeBase {
  ThirdPartyConstraintTypeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetThirdPartyConstraints_ThirdPartyConstraintType?: Array<AssetThirdPartyConstraint> | null;

  constructor(item?: IThirdPartyConstraintType) {
    if (item) {

      this.ThirdPartyConstraintTypeId = item.ThirdPartyConstraintTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetThirdPartyConstraints_ThirdPartyConstraintType = Helpers.createClassArray(AssetThirdPartyConstraint, item.AssetThirdPartyConstraints_ThirdPartyConstraintType);
    }
  }
}